import { Injectable } from '@angular/core';
import { HttpResponse, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { ReservationCancellationReason } from './reservation-cancellation-reason.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class ReservationCancellationReasonService extends AbstractEntityService {

    protected resourceUrl = 'api/reservation-cancellation-reasons';
    private resourceSearchUrl = 'api/_search/reservation-cancellation-reasons';
    protected resourceCountUrl = 'api/_search/count/reservation-cancellation-reasons';

    constructor(protected http: HttpClient) { super(http); }

    create(reservationCancellationReason: ReservationCancellationReason): Observable<ReservationCancellationReason> {
        let copy: ReservationCancellationReason = Object.assign({}, reservationCancellationReason);
        return this.http.post<ReservationCancellationReason>(this.resourceUrl, copy).map((res: ReservationCancellationReason) => {
            return res;
        });
    }

    update(reservationCancellationReason: ReservationCancellationReason): Observable<ReservationCancellationReason> {
        let copy: ReservationCancellationReason = Object.assign({}, reservationCancellationReason);
        return this.http.put<ReservationCancellationReason>(this.resourceUrl, copy).map((res: ReservationCancellationReason) => {
            return res;
        });
    }

    find(id: number): Observable<ReservationCancellationReason> {
        return this.http.get<ReservationCancellationReason>(`${this.resourceUrl}/${id}`).map((res: ReservationCancellationReason) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<ReservationCancellationReason[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationCancellationReason[]>>(this.resourceUrl, options)
            ;
    }


    search(req?: any): Observable<HttpResponse<ReservationCancellationReason[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationCancellationReason[]>>(this.resourceSearchUrl, options)
            ;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason.service.ts